import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("polyline", {
		points: "6.5 9.5 12 15 17.5 9.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronDown;
